import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
export default function QoDocStatus(param) {
    var statusID = param.statusID, statusName = param.statusName, className = param.className;
    var _useState = _sliced_to_array(useState({
        statusName: statusName,
        statusID: statusID
    }), 2), elemData = _useState[0], setElemData = _useState[1];
    useEffect(function() {
        setElemData({
            statusName: statusName,
            statusID: statusID
        });
    }, [
        statusName,
        statusID
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 doc-container qo-doc-status-".concat(elemData.statusID, " ").concat(className),
        children: elemData.statusName
    });
}
